import React from 'react';

import Badge from '@atlaskit/badge';

const BadgeDefaultExample = (): React.JSX.Element => {
	return <Badge>{8}</Badge>;
};

export default BadgeDefaultExample;
